"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author david.grigoryan on 1/15/18
 */
/**
 * @author david.grigoryan on 1/15/18
 */
var Order;
/**
 * @author david.grigoryan on 1/15/18
 */
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order = exports.Order || (exports.Order = {}));
//# sourceMappingURL=order.enum.js.map